import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi, type TrustedDevice } from '../../api/auth';

export function TrustedDevicesPage() {
  const [devices, setDevices] = useState<TrustedDevice[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    setError('');
    try {
      setDevices(await authApi.listTrustedDevices());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load trusted devices');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    void load();
  }, []);

  async function remove(id: string) {
    await authApi.removeTrustedDevice(id);
    await load();
  }

  return (
    <div className="mx-auto max-w-3xl p-6">
      <h1 className="text-2xl font-semibold text-slate-900">Trusted devices</h1>
      <p className="mt-1 text-sm text-slate-600">Devices you marked as trusted with Remember me.</p>
      {error && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
      {loading ? (
        <p className="mt-6 text-slate-600">Loading…</p>
      ) : (
        <ul className="mt-6 space-y-3">
          {devices.map((d) => (
            <li key={d.id} className="flex items-start justify-between rounded-xl border border-slate-200 bg-white p-4">
              <div>
                <p className="font-medium text-slate-900">{d.device_name || 'Unknown device'}</p>
                <p className="text-xs text-slate-500">Last seen: {new Date(d.last_seen_at).toLocaleString()}</p>
              </div>
              <button type="button" onClick={() => void remove(d.id)} className="text-sm text-red-600 hover:underline">
                Remove
              </button>
            </li>
          ))}
          {devices.length === 0 && <li className="text-sm text-slate-600">No trusted devices yet.</li>}
        </ul>
      )}
      <p className="mt-6 text-sm">
        <Link to="/account/security" className="text-blue-600 hover:underline">← Security dashboard</Link>
      </p>
    </div>
  );
}
